import type { Before, Today, NextWeek } from './DayModes.types';

export const BEFORE: Before = 'before';
export const TODAY: Today = 'today';
export const NEXT_WEEK: NextWeek = 'next_week';
